import type { Medication } from '../../../../../../../lib/transferObjects/Medication';
import moveUpDownIcon from '../../../../../../../assets/img/medicine-profile-icons/move-up-down-icon.svg';

type MedicationDragPreviewProps = {
  medication: Partial<Medication>;
};

const MedicationDragPreview = ({ medication }: MedicationDragPreviewProps) => (
  <div
    style={{
      width: 'min(560px, calc(100vw - 48px))',
      padding: '12px 16px',
      borderRadius: 8,
      border: '1px solid rgba(0, 139, 209, 0.28)',
      background: '#ffffff',
      boxShadow: '0 12px 32px rgba(15, 23, 42, 0.18)',
      pointerEvents: 'none',
    }}
  >
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
      <img
        src={moveUpDownIcon}
        alt="drag sort"
        style={{ width: 14, height: 14, marginTop: 4, flexShrink: 0 }}
      />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontWeight: 600 }}>{medication.medName}</div>
        {medication.subheading ? (
          <div
            className="medication-row-sublabel"
            dangerouslySetInnerHTML={{
              __html: medication.subheading ?? '',
            }}
          />
        ) : null}
      </div>
    </div>
  </div>
);

export default MedicationDragPreview;
